import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// routes
import { useParams } from 'src/routes/hooks';
// sections
import { InterviewResultView } from 'src/sections/interview/view';

// ----------------------------------------------------------------------

export default function InterviewResultPage() {
  const params = useParams();
  const [title, setTitle] = useState('');

  const { interviewId, jobId } = params;

  return (
    <>
      <Helmet>
        <title> Hireintel - Interview Result</title>
      </Helmet>

      <InterviewResultView
        setTitle={setTitle}
        interviewId={`${interviewId}`}
        jobId={`${jobId}`}
      />
    </>
  );
}
